import { DomHelper, EventHelper } from '@bryntum/schedulerpro';
import React, { useEffect, useMemo, useRef } from 'react';
// eslint-disable-next-line import/no-internal-modules
import { renderToStaticMarkup } from 'react-dom/server';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { ReactComponent as SearchSvg } from 'assets/svgs/search.svg';
import { EmptyState as EmptyStateAtom } from 'components/atoms/empty-state';
import { store } from 'data';
import { useTranslation } from 'hooks/use-translation';
import { queryClient } from 'queries';
import { SchedulerReference } from '../types';

interface Props {
  schedulerRef: SchedulerReference;
  noData: boolean;
  onReset: () => void;
}
export const useNoDataRender = ({
  noData,
  schedulerRef,
  onReset,
}: Props): void => {
  const noResultDivRef = useRef<ReturnType<typeof DomHelper.createElement>>();
  const noResultMessage = useTranslation(
    'timesheets.tasks.filters.error.no_search_result_line_1',
  );
  const noResultMessage1 = useTranslation(
    'timesheets.tasks.filters.error.no_search_result_line_2',
  );
  const action = useTranslation('resource_management.no_result.action.text');
  const emptyState = useMemo(
    () => (
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <EmptyStateAtom
            image={<SearchSvg />}
            message={
              <>
                {noResultMessage}
                <br />
                {noResultMessage1}
              </>
            }
            secondaryCTA={
              <EmptyStateAtom.CallToAction.Secondary>
                {action}
              </EmptyStateAtom.CallToAction.Secondary>
            }
          />
        </Provider>
      </QueryClientProvider>
    ),
    [action, noResultMessage, noResultMessage1],
  );

  useEffect(() => {
    if (noData) {
      if (noResultDivRef.current != null) {
        return;
      }
      const noResultDiv = DomHelper.createElement({
        tag: 'div',
        className: 'no-result',
        children: [
          {
            html: renderToStaticMarkup(emptyState),
          },
        ],
      });

      EventHelper.addListener(noResultDiv as HTMLElement, 'click', (event) => {
        const isButtonClick = event.target.closest('.ant-btn-link') != null;

        if (isButtonClick) {
          onReset();
        }
      });

      DomHelper.append(
        schedulerRef.current.instance.subGrids.locked.element,
        noResultDiv,
      );
      noResultDivRef.current = noResultDiv;
    } else if (noResultDivRef.current != null) {
      DomHelper.removeEachSelector(
        schedulerRef.current.instance.subGrids.locked.element,
        '.no-result',
      );
      noResultDivRef.current = undefined;
    }
  }, [
    action,
    emptyState,
    noData,
    noResultMessage,
    noResultMessage1,
    onReset,
    schedulerRef,
  ]);
};
